import React from 'react';

import { importComponent } from '@xingternal/hops';

import Header from '@xingternal/pages-header';

const AboutUs = importComponent(
  () => import('@xingternal/pages-about-us/AboutUs')
);
const Jobs = importComponent(() => import('@xingternal/pages-jobs/Jobs'));
const IdealEmployer = importComponent(
  () => import('@xingternal/pages-ideal-employer/IdealEmployer')
);
const NewsContainer = importComponent(
  () => import('@xingternal/pages-news/News/NewsContainer')
);
const Contacts = importComponent(
  () => import('@xingternal/pages-contacts/Contacts')
);
const Locations = importComponent(
  () => import('@xingternal/pages-locations/LocationsContainer')
);
const Kununu = importComponent(
  () => import('@xingternal/pages-kununu/KununuContainer')
);
const Employees = importComponent(
  () => import('@xingternal/pages-employees/Employees')
);
const CompanyRecommendations = importComponent(
  () =>
    import('@xingternal/pages-company-recommendations/CompanyRecommendations')
);
const SampleModule = importComponent(
  () => import('@xingternal/pages-sample-module/SampleModule')
);

const AboutUsDetail = importComponent(
  () => import('@xingternal/pages-about-us/AboutUsDetail')
);
const JobsDetail = importComponent(
  () => import('@xingternal/pages-jobs/JobsDetail')
);
const NewsDetail = importComponent(
  () => import('@xingternal/pages-news/NewsDetail')
);
const ContactsDetail = importComponent(
  () => import('@xingternal/pages-contacts/ContactsDetail')
);
const EmployeesDetail = importComponent(
  () => import('@xingternal/pages-employees/EmployeesDetail')
);
const SampleModuleDetail = importComponent(
  () => import('@xingternal/pages-sample-module/SampleModuleDetail')
);

type modulesMapProps = {
  [name: string]: {
    module: React.ComponentType<any>;
    subpageModule?: React.ComponentType<any>;
    seoIndexSubpage?: boolean;
    featureSwitch?: string;
    tabs?: {
      [tabName: string]: React.ComponentType<any>;
    };
  };
};

const modulesMap: modulesMapProps = {
  header: {
    module: Header,
  },
  about_us: {
    module: AboutUs,
    subpageModule: AboutUsDetail,
  },
  jobs: {
    module: Jobs,
    subpageModule: JobsDetail,
  },
  ideal_employer: {
    module: IdealEmployer,
  },
  news: {
    module: NewsContainer,
    subpageModule: NewsDetail,
  },
  contacts: {
    module: Contacts,
    subpageModule: ContactsDetail,
    seoIndexSubpage: false,
  },
  kununu: {
    module: Kununu,
  },
  employees: {
    module: Employees,
    subpageModule: EmployeesDetail,
  },
  company_recommendations: {
    module: CompanyRecommendations,
  },
  sampleModule: {
    module: SampleModule,
    subpageModule: SampleModuleDetail,
    tabs: {
      tab1: () => <h1>tab 1</h1>,
      tab2: () => <h1>tab 2</h1>,
      tab3: () => <h1>tab 3</h1>,
    },
  },
  locations: {
    module: Locations,
  },
};

export default modulesMap;
